import { AxiosResponse } from 'axios';
import { SyncPlanApiModel } from '../../../types/models/sync/sync-plan.model';
import { TrimbleLayerSyncPlanApiModel } from '../../../types/models/sync/trimble-layer-sync-plan.model';
import { DetermineSyncPlanApiRequest } from '../../../types/requests/sync/determine-sync-plan.request';
import { ExportSyncDraftApiRequest } from '../../../types/requests/sync/export-sync-draft.request';
import { ExportSyncPlanApiRequest } from '../../../types/requests/sync/export-sync-plan.request';
import { ImportTrimbleLayersApiRequest } from '../../../types/requests/sync/import-trimble-layers.request';
import { client } from './client';
import { ImportSymbolsApiRequest } from '../../../types/requests/sync/import-symbols.request';
import { ExportSymbolsApiRequest } from '../../../types/requests/sync/export-symbols.request';

const downloadFile = (response: AxiosResponse) => {
  // TODO: is there a better way of handling the download of the file?
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1].replace(/"/g, ''));
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const determineSyncPlan = ({ fullSync, ...params }: DetermineSyncPlanApiRequest) =>
  client.post<SyncPlanApiModel>('/sync/plan', params, {
    params: { fullSync },
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const applySyncPlan = (params: SyncPlanApiModel) => client.post<SyncPlanApiModel>('/sync', params);

export const exportSyncDraft = async (params: ExportSyncDraftApiRequest) => {
  const response = await client.get('/sync', { params, responseType: 'blob' });
  downloadFile(response);
  return response;
};

export const exportSyncPlan = async (params: ExportSyncPlanApiRequest) => {
  // TODO: is there a better way of handling the download of the file?
  const response = await client.post('/sync/plan/export', params, { responseType: 'blob' });
  downloadFile(response);
  return response;
};

export const importTrimbleLayers = (params: ImportTrimbleLayersApiRequest) =>
  client.post<TrimbleLayerSyncPlanApiModel>('/sync/trimble-layers', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const exportTrimbleLayers = async () => {
  // TODO: is there a better way of handling the download of the file?
  const response = await client.get('/sync/trimble-layers', { responseType: 'blob' });
  downloadFile(response);
  return response;
};

export const importSymbols = ({ libraryId, ...params }: ImportSymbolsApiRequest) =>
  client.post<TrimbleLayerSyncPlanApiModel>(`/sync/symbols/${libraryId}`, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const exportSymbols = async ({ libraryId }: ExportSymbolsApiRequest) => {
  // TODO: is there a better way of handling the download of the file?
  const response = await client.get(`/sync/symbols/${libraryId}`, { responseType: 'blob' });
  downloadFile(response);
  return response;
};
